export default "/images/8920d61149698052df24992f37eae588.avif";